import { UiStructure } from "./Form_For_Inventory";

const Colouring_Activity_Book = () => (
  <UiStructure
    title={"Colouring Activity Book"}
    label={"Colouring Activity Book"}
    fileStoreId={"8e4cb6e6-3c14-4452-a36d-53484df03d52"}
  />
);

export default Colouring_Activity_Book;
